import React from 'react';

const ItemComment = (props) => {
    return (
        <div className={`item-cmntticket ${props.data.is_reply ? 'replayed' : ''}`}>
            <p>{props.data.comment}</p>
            {props.data.image == null ?
                null
                :
                <img src={props.data.image} />
            }
            <span>{props.data.jdate}</span>
        </div>
    );
}

export default ItemComment;